import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Tabs, Popconfirm, Collapse, Alert, Button, Row, Col, Layout, Drawer, Popover, Icon, Input, Menu, Switch, Tooltip, Radio, Spin, notification, Card } from 'antd';
import ContentTitle from '../../../core/ui/content-header';
import { navigate } from '../../../core/ui/link';
import { CacheProps, withCache } from '../../../core/services/cache.service';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import HttpService, { formatMessage } from '../../../core/services/http.service';
import JoditRichEditor from "../../../components/joditEditor";
import autobind from "autobind-decorator";
import { resolve } from '../../../inversify.config';
import HighlightedText, { removeHtmlTags } from "../../../components/highlighted"
import { authenticationService, IdentityProps, withIdentity } from '../../../core/services/authentication';
import { createPatch } from 'rfc6902';
import { CommandResult } from "../../../core/stores/types";
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';


import _ from "lodash"
import header from "../../../core/ui/header";
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";
const { Panel } = Collapse;
const { Search } = Input;
const { SubMenu } = Menu;
const { TabPane } = Tabs;



interface UserGuideEditorState {
    editItem: string,
    items: any,
    addSubSection: string,
    newSectionTitle: string,
    selectedSection: string,
    openedSubMenus: string[],
    initialMenuItemSelected: string
    changedRichText: string,
    isAdmin: boolean,
    isAdminFi: boolean,
    isBusy: boolean,
    results?: any[]
    query?: string,
    previewMode: boolean,
    load: boolean;
    currentKeys: string[]
}

interface UserGuideEditorProps {

}

interface NewUserGuideItem {
    title: string,
    content: string,
}

interface UserGuideItem {
    id: string,
    title: string,
    content: string,
    fatherId?: string,
    children?: string[]
}

class UserGuideEditor extends React.Component<RouteComponentProps & UserGuideEditorProps & WithTranslation & UserProfileProps & CacheProps, UserGuideEditorState> {
    @resolve(HttpService)
    private httpService!: HttpService;
    private myRef: any;

    constructor(props: RouteComponentProps & UserGuideEditorProps & WithTranslation & UserProfileProps & CacheProps) {
        super(props);
        this.myRef = React.createRef()
        this.state = {
            editItem: '',
            items: {} as any,
            addSubSection: '',
            newSectionTitle: '',
            selectedSection: '',
            openedSubMenus: [],
            initialMenuItemSelected: '',
            changedRichText: '',
            isAdmin: false,
            isAdminFi: false,
            isBusy: true,
            previewMode: false,
            load: false,
            currentKeys: []

        };
    }

    componentWillMount() {
        this.load(true)

    }
    @autobind
    private isAdmin() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Pmo Administrator")
                || this.props.userProfile.roles.includes("Administrator")
                || this.props.userProfile.roles.includes("FIConsultant")
                || this.props.userProfile.roles.includes("ClientAdmin")
            );
    }

    @autobind
    private isAdminFi() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.filter(o => o.includes("FIConsultant"))).length > 0;
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }


    @autobind
    async load(firstTime: boolean = false) {
        var url = '';
        url = `${process.env.PUBLIC_URL}/api/v1/manual`;

        await this.httpService.get<any>(url).then(result => {
            let items = {} as any
            let values: any[] = Object.values(result.data.items).sort((a: any, b: any) => a.order - b.order)
            if (firstTime) {
                if (values.length > 0) {
                    this.setState({ selectedSection: values[0].id }
                    )
                }
            }
            values.forEach((value: any) => items[value.id] = value)
            this.setState({ editItem: '', load: true, newSectionTitle: '', query: undefined, results: undefined, isBusy: false, items: items, isAdmin: this.isAdmin()!, isAdminFi: this.isAdminFi()!, previewMode: !this.isAdminFi()!,changedRichText: values.length > 0 ? values[0].content : '', initialMenuItemSelected: this.state.selectedSection != '' ? this.state.selectedSection : (values.length > 0 ? values[0].id : '') })
        }).catch(error => {
            return
        })

    }
    @autobind
    private searchNode(node: any, query: string) {
        var results = []
        var isMatch = false

        const regex = new RegExp(`(${_.escapeRegExp(query)})`, 'gi')

        if (node.title.match(regex)) {
            results.push(node)
            isMatch = true
        }

        node.contents = []
        if (node.content.length > 0) {
            try {
                if (node.content.match(regex)) {
                    if (!isMatch) {
                        results.push(node)
                        isMatch = true
                    }
                    if (node.contents) {
                        node.contents.push(removeHtmlTags(node.content))
                    }
                }
            } catch (e) { }
        }

        return results
    }

    @autobind
    private renderResults(results: any[], query?: string) {
        const { t } = this.props
        var resultText = (results.length == 1) ? t('Result') : t('Results')
        return (
            <div style={{ marginTop: 5 }}>
                <h5 style={{ textAlign: 'center' }}>
                    {`${results.length} ${resultText}`}
                </h5>
                <ul>
                    {results.map((node: any) => {
                        return (
                            <li style={{ cursor: 'pointer', marginBottom: 10 }} onClick={() => { this.setState({ selectedSection: node.id }) }}>
                                <HighlightedText text={node.title} highlight={query} />
                                {node.content && node.content.length > 0 &&
                                    <div>
                                        <ul className="search-content">
                                            {node.contents.map((content: string) => {
                                                return (
                                                    <li>
                                                        <HighlightedText text={content} highlight={query} />
                                                    </li>)
                                            })}
                                        </ul>
                                    </div>
                                }
                            </li>)
                    })}
                </ul>
            </div>
        )
    }
    @autobind
    private onSearch(query: string) {
        this.setState({ isBusy: true })
        var results = [] as any
        Object.values(this.state.items).forEach(node => { results = results.concat(this.searchNode(node, query)) })
        this.setState({ query: query, isBusy: false, results: results })
    }

    @autobind
    selectElement(id: string) {
        this.setState({ selectedSection: id, editItem: '', addSubSection: '', newSectionTitle: '', changedRichText: '', })
    }
    @autobind
    async addSection(fatherId?: string) {
        const { t } = this.props;
        if (this.state.newSectionTitle == '') {
            this.setState({ isBusy: false }, () => this.countDownNotification(notification.error, t('Error'), t('Title cannot be empty'), 'error'))
            return
        }
        var url = `${process.env.PUBLIC_URL}/api/v1/manual`;
        var data = { 'title': this.state.newSectionTitle, 'content': '' } as any
        if (fatherId) {
            data['fatherId'] = fatherId
        }
        var order = 0
        var items = Object.values(this.state.items)
        var filtered = items.filter((i: any) => i.fatherId == fatherId)
        filtered.forEach((node: any) => {
            if (node.order && node.order > order)
                order = node.order
        })
        order += 1
        data['order'] = order

        await this.httpService.post<any, NewUserGuideItem>(url, data).then(result => {
            this.load()
            this.setState({ isBusy: false, addSubSection: '', newSectionTitle: '' }, () => this.countDownNotification(notification.success, t('Success'), t('Section added successfully'), 'success'))
        }).catch(error => {
            this.setState({ isBusy: false }, () => this.countDownNotification(notification.error, t('Error'), t('There was an error'), 'error'))
        })
    }
    @autobind
    async deleteSection(id: string) {
        const { t } = this.props;
        var url = `${process.env.PUBLIC_URL}/api/v1/manual/${id}`;
        await this.httpService.delete<any, NewUserGuideItem>(url).then(result => {
            this.load()
            this.setState({ isBusy: false, addSubSection: '', newSectionTitle: '', selectedSection: '' }, () => this.countDownNotification(notification.success, t('Success'), t('Section deleted successfully'), 'success'))
        }).catch(error => {
            this.setState({ isBusy: false }, () => this.countDownNotification(notification.error, t('Error'), t('There was an error'), 'error'))
        })
    }

    @autobind
    getAncestorsIds(id: string): string[] {
        const items = Object.entries(this.state.items).map((item: any) => item[1]);
        const element = items.find((item) => item.id === id);
        if (!element) {
            return [];
        }
        const ancestors: string[] = [element.id];
        if (element.fatherId) {
            const fatherAncestors = this.getAncestorsIds(element.fatherId);
            ancestors.push(...fatherAncestors);
        }
        return ancestors;
    }

    @autobind
    setCurrentIds(element: any) {
        const ids: string[] = this.getAncestorsIds(element.id);
        this.setState({
            currentKeys: [...this.state.currentKeys, ...ids.filter((id) => !this.state.currentKeys.includes(id))]
        });
        setTimeout(() => {
            scroller.scrollTo(element.id, { smooth: true, spy: true });
        }, 100);
    };

    @autobind
    getNestedIds(id: string): string[] {
        const items = Object.entries(this.state.items).map((item: any) => item[1]);
        const element = items.find((item: any) => item.id === id);
        if (!element) {
            return [];
        }
        const nested: string[] = [element.id];
        if (element.children && element.children.length > 0) {
            for (const child of element.children) {
                const childNested = this.getNestedIds(child);
                nested.push(...childNested);
            }
        }
        return nested;
    }



    @autobind
    handleOnChange(key: string | string[]) {
        const newKeys = typeof key === "string" ? [key] : key;
        const nested: string[] = [];
        if (this.state.currentKeys.filter((k) => !newKeys.includes(k)).length > 0) {
            for (const item of this.state.currentKeys.filter(
                (k) => !newKeys.includes(k)
            )) {
                const ids = this.getNestedIds(item);
                nested.push(...ids.filter((k) => !nested.includes(k)));
            }
        }
        this.setState({ currentKeys: newKeys.filter((k) => !nested.includes(k)) });
    };

    @autobind
    getPreviewMenuChildren(element: any) {
        const customPanelStyle = {
            backgroundColor: 'transparent',
            border: 0,
            overflow: 'hidden',
        };
        return (<Panel id={element.id} header={<Link onClick={() => { this.setCurrentIds(element) }} to={element.id} > {element.title}</Link>} key={element.id} style={customPanelStyle}>

            <Collapse bordered={false} style={{ backgroundColor: 'transparent' }}>
                {element["children"].map((child: any) => this.getPreviewMenuChildren(this.state.items[child]))}
            </Collapse>
        </Panel>)


    }

    @autobind
    getMenuChildren(element: any, siblings?: any) {
        const { t } = this.props;
        let menuItem = undefined
        if (element["children"].length > 0) {
            if (this.state.editItem == element.id) {
                menuItem = <SubMenu key={element.id}
                    title={
                        <div>
                            <Input value={this.state.newSectionTitle} onChange={e => this.setState({ newSectionTitle: e.target.value })} style={{ width: "100px" }} /> <Icon type="save" onClick={() => this.editSection(true, element.id, undefined)} />  <Icon onClick={() => this.setState({ editItem: '', })} type="close" />
                        </div>
                    }>
                    {element["children"].map((child: any) => { return this.getMenuChildren(this.state.items[child], element["children"]) })}
                </SubMenu>
            }

            else {

                menuItem = <SubMenu onTitleClick={() => {
                    if (this.state.selectedSection != (element.id)) {
                        this.selectElement(element.id);
                    } else {
                        this.selectElement('');
                    }
                }
                } key={element.id.toString()}
                    title={
                        <div style={{ color: this.state.selectedSection === element.id ? '#1890FF' : 'inherit' }}>
                            {this.state.isAdmin && this.state.isAdminFi && !this.state.previewMode && < Popover
                                content={
                                    <Menu mode="vertical">
                                        <Menu.Item key={element.id.toString() + "add"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.setState({ selectedSection: '', addSubSection: element.id, editItem: '', openedSubMenus: this.state.openedSubMenus.includes(element.id) ? this.state.openedSubMenus : [...this.state.openedSubMenus, element.id] }) }}> <Icon type="plus" />{t("Add subsection")}</a>
                                        </Menu.Item >
                                        <Menu.Item key={element.id.toString() + "edit"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.setState({ addSubSection: '', editItem: element.id, selectedSection: element.id, newSectionTitle: element.title }) }}><Icon type="edit" />{t("Edit title")}</a>
                                        </Menu.Item>
                                        <Menu.Item key={element.id.toString() + "delete"}>
                                            <Popconfirm
                                                title={t("Are you sure you want to delete this section and all of its subsections?")}
                                                onConfirm={(e) => { e.stopPropagation(); this.deleteSection(element.id) }}
                                                okText={t("Yes")}
                                                cancelText={t("No")}
                                            >
                                                <a onClick={(e) => { e.stopPropagation() }}><Icon type="delete" />{t("Delete section and subsections")}</a>
                                            </Popconfirm>
                                        </Menu.Item >
                                        {element.order > 0 && <Menu.Item key={element.id.toString() + "up"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(true, element.id) }}><Icon type="up" />{t("Change section order (up)")}</a>
                                        </Menu.Item>}
                                        {siblings.length > 0 && siblings[siblings.length - 1] != element.id.toString() && < Menu.Item key={element.id.toString() + "down"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(false, element.id) }}><Icon type="down" />{t("Change section order (down)")}</a>
                                        </Menu.Item>}
                                    </Menu>

                                }
                            >
                                <Icon type="more" />
                            </Popover>}
                            {element.title}
                        </div>
                    }>

                    {element["children"].map((child: any) => { return this.getMenuChildren(this.state.items[child], element["children"]) })}
                    {this.state.addSubSection == element.id &&
                        <Menu.Item style={{ height: '75px' }}>
                            <span><Input style={{ width: "100px" }} defaultValue={this.state.newSectionTitle} onChange={e => this.setState({ newSectionTitle: e.target.value })} /></span> <br /><span><Icon type="save" onClick={() => this.addSection(element.id)} />  <Icon onClick={() => this.setState({ addSubSection: '', newSectionTitle: "" })} type="close" /></span>
                        </Menu.Item>}
                </SubMenu>
            }

        }
        else {//doesn't have children
            if (this.state.editItem == element.id) {
                menuItem = <Menu.Item key={element.id} style={{ height: '75px' }}>
                    <span><Input value={this.state.newSectionTitle} onChange={e => this.setState({ newSectionTitle: e.target.value })} style={{ width: "100px" }} /></span> <br /><span><Icon type="save" onClick={() => this.editSection(true, element.id, undefined)} />  <Icon onClick={() => this.setState({ editItem: "", selectedSection: '' })} type="close" /></span>
                </Menu.Item>
            }

            else {
                menuItem = this.state.addSubSection == element.id ?

                    <SubMenu onTitleClick={() => this.selectElement(element.id)} key={element.id.toString()}
                        title={
                            <div>
                                {this.state.isAdmin && this.state.isAdminFi && !this.state.previewMode &&
                                    <Popover
                                        content={
                                            <Menu mode="vertical">
                                                <Menu.Item key={element.id.toString() + "add"}>
                                                    <a onClick={(e) => { e.stopPropagation(); this.setState({ selectedSection: '', addSubSection: element.id, editItem: '', openedSubMenus: this.state.openedSubMenus.includes(element.id) ? this.state.openedSubMenus : [...this.state.openedSubMenus, element.id] }) }}> <Icon type="plus" />{t("Add subsection")}</a>
                                                </Menu.Item >
                                                <Menu.Item key={element.id.toString() + "edit"}>
                                                    <a onClick={(e) => { e.stopPropagation(); this.setState({ editItem: element.id, addSubSection: '', selectedSection: element.id, newSectionTitle: element.title }) }}><Icon type="edit" />{t("Edit title")}</a>
                                                </Menu.Item>
                                                <Menu.Item key={element.id.toString() + "delete"}>
                                                    <Popconfirm

                                                        title={t("Are you sure you want to delete this section and all of its subsections?")}
                                                        onConfirm={(e) => { e.stopPropagation(); this.deleteSection(element.id) }}
                                                        okText={t("Yes")}
                                                        cancelText={t("No")}
                                                    >
                                                        <a onClick={(e) => { e.stopPropagation() }}><Icon type="delete" />{t("Delete section and subsections")}</a>
                                                    </Popconfirm>
                                                </Menu.Item >
                                                {element.order > 0 && <Menu.Item key={element.id.toString() + "up"}>
                                                    <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(true, element.id) }}><Icon type="up" />{t("Change section order (up)")}</a>
                                                </Menu.Item>}
                                                {siblings.length > 0 && siblings[siblings.length - 1] != element.id.toString() && < Menu.Item key={element.id.toString() + "down"}>
                                                    <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(false, element.id) }}><Icon type="down" />{t("Change section order (down)")}</a>
                                                </Menu.Item>}
                                            </Menu>


                                        }
                                    >
                                        <Icon type="more" />
                                    </Popover>}
                                {element.title}
                            </div>
                        }>

                        <Menu.Item style={{ height: '75px' }}>
                            <span><Input style={{ width: "150px" }} defaultValue={this.state.newSectionTitle} onChange={e => this.setState({ newSectionTitle: e.target.value })} /></span><br /><span> <Icon type="save" onClick={() => this.addSection(element.id)} />  <Icon onClick={() => this.setState({ addSubSection: '', newSectionTitle: "" })} type="close" /></span>
                        </Menu.Item>
                    </SubMenu>
                    :
                    < Menu.Item onClick={() => this.selectElement(element.id)} key={element.id} >
                        {this.state.isAdmin && this.state.isAdminFi && !this.state.previewMode &&
                            <Popover
                                content={
                                    <Menu mode="vertical">
                                        <Menu.Item key={element.id.toString() + "add"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.setState({ selectedSection: '', addSubSection: element.id, editItem: '', openedSubMenus: this.state.openedSubMenus.includes(element.id) ? this.state.openedSubMenus : [...this.state.openedSubMenus, element.id] }) }}> <Icon type="plus" />{t("Add subsection")}</a>
                                        </Menu.Item >
                                        <Menu.Item key={element.id.toString() + "edit"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.setState({ addSubSection: '', editItem: element.id, selectedSection: element.id, newSectionTitle: element.title }) }}><Icon type="edit" />{t("Edit title")}</a>
                                        </Menu.Item>
                                        <Menu.Item key={element.id.toString() + "delete"}>
                                            <Popconfirm
                                                title={t("Are you sure you want to delete this section and all of its subsections?")}
                                                onConfirm={(e) => { e.stopPropagation(); this.deleteSection(element.id) }}
                                                okText={t("Yes")}
                                                cancelText={t("No")}
                                            >
                                                <a onClick={(e) => { e.stopPropagation() }}><Icon type="delete" />{t("Delete section and subsections")}</a>
                                            </Popconfirm>
                                        </Menu.Item >
                                        {element.order > 0 && <Menu.Item key={element.id.toString() + "up"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(true, element.id) }}><Icon type="up" />{t("Change section order (up)")}</a>
                                        </Menu.Item>}
                                        {siblings.length > 0 && siblings[siblings.length - 1] != element.id.toString() && < Menu.Item key={element.id.toString() + "down"}>
                                            <a onClick={(e) => { e.stopPropagation(); this.editSectionOrder(false, element.id) }}><Icon type="down" />{t("Change section order (down)")}</a>
                                        </Menu.Item>}
                                    </Menu>
                                }
                            >
                                <Icon type="more" />
                            </Popover>

                        }    {element.title}
                    </Menu.Item >
            }
        }
        return menuItem
    }

    @autobind
    getCollapseChildren(element: any) {
        const customPanelStyle = {
            backgroundColor: 'transparent',
            border: 0,
            overflow: 'hidden',
        };
        return (<Panel id={element.id} header={<Element name={element.id}>{element.title}</Element>} key={element.id} style={customPanelStyle}>
            <div dangerouslySetInnerHTML={{ __html: element.content }} />

            <Collapse onChange={this.handleOnChange} activeKey={this.state.currentKeys} bordered={false} style={{ backgroundColor: 'transparent' }}>
                {element["children"].map((child: any) => this.getCollapseChildren(this.state.items[child]))}
            </Collapse>
        </Panel>)
    }

    @autobind
    editContent(newContent: string) {
        this.editSection(false, this.state.selectedSection, newContent)
    }

    @autobind
    async editSection(changeTitle: boolean, id: string, newContent?: string) {
        const { t } = this.props;
        this.setState({ isBusy: true })
        var url = `${process.env.PUBLIC_URL}/api/v1/manual/${id}`;
        let changes = []
        if (changeTitle) {
            if (this.state.newSectionTitle == '') {
                this.setState({ isBusy: false }, () => this.countDownNotification(notification.error, t('Error'), t('Title cannot be empty'), 'error'))
                return
            }
            changes.push({ "op": "replace", "path": "/Title", "value": this.state.newSectionTitle })
        }
        else
            changes.push({ "op": "replace", "path": "/Content", "value": newContent! })
        await this.httpService.patch(url, changes).then(result => {
            const { t } = this.props;
            this.countDownNotification(notification.success, t('Success'), t('Section saved successfully'), 'success')
            this.load();

        })
            .catch(error => {
                this.setState({ isBusy: false })
            })
    }
    @autobind
    async editSectionOrder(moveUp: boolean, id: any) {
        const { t } = this.props;
        this.setState({ isBusy: true })
        var url = `${process.env.PUBLIC_URL}/api/v1/manual/${moveUp ? 'moveUp' : 'moveDown'}/${id}`;
        await this.httpService.post(url, undefined).then(result => {
            const { t } = this.props;
            this.countDownNotification(notification.success, t('Success'), t('Section moved successfully'), 'success')
            this.load();
        })
            .catch(error => {
                this.setState({ isBusy: false })
            })
    }

    @autobind
    onChangeNewSection() {

    }

    @autobind
    getEditorValue(value: string) {
        this.setState({ changedRichText: value })
    }

    render() {
        const { t } = this.props;
        return (
            <Spin spinning={this.state.isBusy}>
                <div>
                    <Row gutter={0}>
                        <Col span={10}>
                            <ContentTitle title={t("User guide / FAQ")} />
                        </Col>

                    </Row>
                    <Layout >
                        <Layout.Sider
                            width="20%"
                            theme="light">
                            <Tabs
                                type="card"
                                style={{ zIndex: 0 }}
                                tabBarExtraContent={this.state.isAdminFi ? (this.state.previewMode ? <div><Tooltip title={t("Change to edition mode")}>< Button onClick={() => this.setState({ previewMode: false })} shape="circle" icon="edit" /></Tooltip></div> : <div><Tooltip title={t("Change to preview mode")}>< Button onClick={() => this.setState({ previewMode: true })} shape="circle" icon="eye" /></Tooltip></div>) : ''}
                            >

                                <TabPane tab={<div><Icon type='menu' />{t("Menu")}</div>} key={"menu"} >

                                    {this.state.isAdmin && this.state.isAdminFi && !this.state.previewMode &&

                                        <div>
                                            <Menu defaultSelectedKeys={[this.state.selectedSection != '' ? this.state.selectedSection : this.state.initialMenuItemSelected]} selectedKeys={[this.state.selectedSection != '' ? this.state.selectedSection : this.state.initialMenuItemSelected]} mode="inline" defaultOpenKeys={this.state.openedSubMenus} openKeys={this.state.openedSubMenus} onOpenChange={(openKeys: string[]) => this.setState({ openedSubMenus: this.state.openedSubMenus.includes(this.state.selectedSection.toString()) ? [...openKeys, this.state.selectedSection.toString()] : [...openKeys] })}>
                                                {Object.entries(this.state.items).map((item: any) => {
                                                    if (!item[1].fatherId)
                                                        return this.getMenuChildren(item[1], Object.entries(this.state.items).filter((i: any) => !i.fatherId).map((i: any) => i[1].id))
                                                })
                                                }
                                                {this.state.addSubSection == 'new' && < Menu.Item style={{ height: '75px' }} >
                                                    <span><Input style={{ width: "150px" }} defaultValue={this.state.newSectionTitle} onChange={e => this.setState({ newSectionTitle: e.target.value })} /></span><br /><span><Icon type="save" onClick={() => this.addSection(undefined)} />  <Icon onClick={() => this.setState({ addSubSection: '', newSectionTitle: "", selectedSection: '' })} type="close" /></span>
                                                </Menu.Item>}
                                            </Menu>
                                            <Button disabled={this.state.addSubSection != ''} style={{ marginBottom: '10px', float: 'right' }} onClick={() => { this.setState({ addSubSection: 'new', selectedSection: '', editItem: '', newSectionTitle: '' }) }} icon="plus" >{t("Add section")}</Button>
                                        </div>}
                                    {(!this.state.isAdmin || this.state.previewMode) &&
                                        <div>
                                                <Collapse bordered={false} style={{ backgroundColor: 'transparent' }}>                                                    
                                                {Object.entries(this.state.items).map((item: any) => {
                                                    if (!item[1].fatherId)
                                                        return this.getPreviewMenuChildren(item[1])
                                                })
                                                    }
                                                </Collapse>
                                        </div>
                                    }
                                </TabPane>
                                <TabPane disabled={this.state.previewMode || this.state.isAdminFi} tab={<div><Icon type='search' />{t("Search")}</div>} key={"search"}>
                                    <Search onSearch={this.onSearch} />
                                    <Spin spinning={this.state.isBusy} style={{ alignSelf: 'center' }}>
                                        {this.state.results && this.renderResults(this.state.results, this.state.query)}
                                    </Spin>
                                </TabPane>

                            </Tabs>
                        </Layout.Sider>
                        <Layout.Content>
                            <Spin spinning={this.state.isBusy} style={{ alignSelf: 'center' }}>
                                {this.state.isAdmin && this.state.isAdminFi && this.state.load && !this.state.isBusy && !this.state.previewMode && (this.state.selectedSection != '' || this.state.initialMenuItemSelected != '') &&
                                    <div style={{ marginTop: '32px' }}>
                                        <JoditRichEditor readOnly={!this.state.isAdmin} key='jodit' initialValue={Object.keys(this.state.items).length > 0 ? this.state.addSubSection != '' ? '' : this.state.items[this.state.selectedSection != '' ? this.state.selectedSection : this.state.initialMenuItemSelected].content : ''} onSave={(text: string) => this.editContent(text)} />
                                    </div>
                                }
                            </Spin>
                            {(!this.state.isAdmin || this.state.previewMode) &&
                                <div className={"user-guide"} style={{ marginTop: '32px' }}>
                                    <Collapse onChange={this.handleOnChange} activeKey={this.state.currentKeys} bordered={false} style={{ backgroundColor: 'transparent' }}>
                                        {
                                            Object.entries(this.state.items).map((item: any) => {
                                                if (!item[1].fatherId)
                                                    return this.getCollapseChildren(item[1])
                                            })
                                        }
                                    </Collapse>
                                </div>
                            }
                        </Layout.Content>
                    </Layout>
                </div>
            </Spin>)
    }
}

export default (withUserProfile(withCache(withIdentity(withRouter(withTranslation()(UserGuideEditor) as any) as any))) as any) as React.ComponentClass<UserGuideEditorProps>;